import { render, staticRenderFns } from "./PremiosEDestaques.vue?vue&type=template&id=24f46382&scoped=true&lang=pug"
import script from "./PremiosEDestaques.vue?vue&type=script&lang=js"
export * from "./PremiosEDestaques.vue?vue&type=script&lang=js"
import style0 from "./PremiosEDestaques.styl?vue&type=style&index=0&id=24f46382&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f46382",
  null
  
)

export default component.exports